module.exports = __webpack_public_path__ + "img/sy.d118c062.png";